(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    var closeButtons = drawer.querySelectorAll('[data-cart-drawer-close]');
    var toggleButtons = document.querySelectorAll('[data-cart-drawer-toggle]');

    function openDrawer() {
      drawer.classList.add('cart-drawer--open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.classList.remove('cart-drawer--open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }

    toggleButtons.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        openDrawer();
      });
    });

    closeButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        closeDrawer();
      });
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('cart-drawer--open')) {
        closeDrawer();
      }
    });

    drawer.addEventListener('click', function(e) {
      var minusBtn = e.target.closest('[data-drawer-minus]');
      var plusBtn = e.target.closest('[data-drawer-plus]');
      var removeBtn = e.target.closest('[data-drawer-remove]');

      if (minusBtn) {
        var item = minusBtn.closest('[data-drawer-item]');
        var qtyEl = item.querySelector('[data-drawer-qty]');
        var val = parseInt(qtyEl.textContent, 10);
        if (val > 1) {
          qtyEl.textContent = val - 1;
          minusBtn.disabled = (val - 1) <= 1;
          window.CartSync && CartSync.update(item.getAttribute('data-item-key'), val - 1);
        }
        return;
      }

      if (plusBtn) {
        var item = plusBtn.closest('[data-drawer-item]');
        var qtyEl = item.querySelector('[data-drawer-qty]');
        var val = parseInt(qtyEl.textContent, 10);
        var max = parseInt(plusBtn.getAttribute('data-max'), 10) || 99;
        if (val < max) {
          qtyEl.textContent = val + 1;
          var minBtn = item.querySelector('[data-drawer-minus]');
          if (minBtn) minBtn.disabled = false;
          window.CartSync && CartSync.update(item.getAttribute('data-item-key'), val + 1);
        }
        return;
      }

      if (removeBtn) {
        var item = removeBtn.closest('[data-drawer-item]');
        item.style.opacity = '0.3';
        window.CartSync && CartSync.update(item.getAttribute('data-item-key'), 0);
        return;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function() {
    function getKey(el) {
      var item = el.closest('[data-item-key]');
      return item ? item.getAttribute('data-item-key') : null;
    }

    document.querySelectorAll('[data-qty-minus]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = btn.closest('.cart__quantity-controls').querySelector('[data-qty-input]');
        if (!input) return;
        var val = parseInt(input.value, 10);
        if (val > 1) {
          input.value = val - 1;
          btn.disabled = (val - 1) <= 1;
          var key = getKey(btn);
          if (key && window.CartSync) CartSync.update(key, val - 1);
        }
      });
    });

    document.querySelectorAll('[data-qty-plus]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = btn.closest('.cart__quantity-controls').querySelector('[data-qty-input]');
        if (!input) return;
        var val = parseInt(input.value, 10);
        var max = parseInt(btn.getAttribute('data-max'), 10) || 99;
        if (val < max) {
          input.value = val + 1;
          var minusBtn = btn.closest('.cart__quantity-controls').querySelector('[data-qty-minus]');
          if (minusBtn) minusBtn.disabled = false;
          var key = getKey(btn);
          if (key && window.CartSync) CartSync.update(key, val + 1);
        }
      });
    });

    document.querySelectorAll('[data-qty-input]').forEach(function(input) {
      input.addEventListener('change', function() {
        var val = parseInt(input.value, 10);
        var max = parseInt(input.max, 10) || 99;
        if (isNaN(val) || val < 1) { input.value = 1; val = 1; }
        if (val > max) { input.value = max; val = max; }
        var key = getKey(input);
        if (key && window.CartSync) CartSync.update(key, val);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function() {
    function parseVariants(str) {
      var map = {};
      if (!str) return map;
      str.split(',').forEach(function(entry) {
        var parts = entry.split(':');
        if (parts.length >= 2) {
          map[parts[0]] = { id: parts[1], price: parts[2] || null };
        }
      });
      return map;
    }

    function hasSize(sizesStr, size) {
      var arr = sizesStr.split(',').filter(function(s) { return s !== ''; });
      return arr.indexOf(size) !== -1;
    }

    function formatMoney(cents) {
      return (cents / 100).toFixed(2);
    }

    var pills = document.querySelectorAll('[data-size-filter] [data-size]');
    pills.forEach(function(pill) {
      pill.addEventListener('click', function() {
        pills.forEach(function(p) { p.classList.remove('catalog__size-pill--active'); });
        pill.classList.add('catalog__size-pill--active');
        var size = pill.getAttribute('data-size');
        var cards = pill.closest('.catalog__inner').querySelectorAll('.product-card');
        cards.forEach(function(card) {
          var badge = card.querySelector('.product-card__badge');
          var btn = card.querySelector('.product-card__button');
          var idInput = card.querySelector('input[name="id"]');
          var priceEl = card.querySelector('[data-product-price]');
          var variants = parseVariants(card.getAttribute('data-variants'));
          var isProductAvailable = card.getAttribute('data-available') === 'true';
          card.style.display = '';

          function setAvailable(c, b, bt) {
            c.style.opacity = '';
            if (b) b.style.display = 'none';
            if (bt) {
              bt.disabled = false;
              bt.type = 'submit';
              bt.classList.remove('product-card__button--disabled');
              bt.textContent = bt.getAttribute('data-add-text') || bt.textContent;
            }
          }

          function setSoldOut(c, b, bt) {
            c.style.opacity = '0.5';
            if (b) b.style.display = '';
            if (bt) {
              bt.disabled = true;
              bt.type = 'button';
              bt.classList.add('product-card__button--disabled');
              bt.textContent = bt.getAttribute('data-sold-text') || bt.textContent;
            }
          }

          if (size === 'all') {
            if (isProductAvailable) {
              setAvailable(card, badge, btn);
            } else {
              setSoldOut(card, badge, btn);
            }
          } else {
            var sizes = card.getAttribute('data-sizes') || '';
            if (hasSize(sizes, size)) {
              setAvailable(card, badge, btn);
              if (variants[size]) {
                if (idInput) idInput.value = variants[size].id;
                if (priceEl && variants[size].price) {
                  var cents = parseInt(variants[size].price, 10);
                  priceEl.setAttribute('data-price-cents', cents);
                  priceEl.textContent = window.W4U ? W4U.formatPrice(cents) : '€' + formatMoney(cents);
                }
              }
            } else {
              setSoldOut(card, badge, btn);
            }
          }
        });
      });
    });

    var sgBtn = document.querySelector('[data-catalog-size-guide-toggle]');
    var sgModal = document.querySelector('[data-size-guide-modal]');
    if (sgBtn && sgModal) {
      sgBtn.addEventListener('click', function() {
        sgModal.classList.add('size-guide-modal--open');
        sgModal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
      sgModal.querySelectorAll('[data-size-guide-close]').forEach(function(el) {
        el.addEventListener('click', function() {
          sgModal.classList.remove('size-guide-modal--open');
          sgModal.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        });
      });
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && sgModal.classList.contains('size-guide-modal--open')) {
          sgModal.classList.remove('size-guide-modal--open');
          sgModal.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        }
      });
    }

    /* Infinite scroll */
    var grid = document.querySelector('[data-infinite-grid]');
    var loader = document.querySelector('[data-infinite-loader]');
    var nextInput = document.querySelector('[data-infinite-next]');
    var loading = false;

    if (grid && loader && nextInput) {
      var observer = new IntersectionObserver(function(entries) {
        if (entries[0].isIntersecting && !loading) {
          var nextUrl = nextInput.value;
          if (!nextUrl) return;
          loading = true;
          loader.classList.add('collection-loader--visible');

          fetch(nextUrl)
            .then(function(res) { return res.text(); })
            .then(function(html) {
              var parser = new DOMParser();
              var doc = parser.parseFromString(html, 'text/html');
              var newCards = doc.querySelectorAll('[data-infinite-grid] .product-card');
              var newNext = doc.querySelector('[data-infinite-next]');

              newCards.forEach(function(card) {
                grid.appendChild(card);
              });

              if (newNext) {
                nextInput.value = newNext.value;
              } else {
                nextInput.value = '';
                loader.style.display = 'none';
                observer.disconnect();
              }

              loading = false;
              loader.classList.remove('collection-loader--visible');
            })
            .catch(function() {
              loading = false;
              loader.classList.remove('collection-loader--visible');
            });
        }
      }, {
        rootMargin: '200px'
      });

      observer.observe(loader);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('.faq');
    if (!section) return;

    section.addEventListener('click', function(e) {
      var button = e.target.closest('.faq__question');
      if (!button) return;

      var item = button.closest('.faq__item');
      var answer = item.querySelector('.faq__answer');
      var isOpen = item.classList.contains('is-open');

      var allItems = section.querySelectorAll('.faq__item.is-open');
      for (var i = 0; i < allItems.length; i++) {
        if (allItems[i] !== item) {
          allItems[i].classList.remove('is-open');
          allItems[i].querySelector('.faq__question').setAttribute('aria-expanded', 'false');
          var otherAnswer = allItems[i].querySelector('.faq__answer');
          otherAnswer.style.maxHeight = null;
          otherAnswer.setAttribute('aria-hidden', 'true');
        }
      }

      if (isOpen) {
        item.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');
        answer.style.maxHeight = null;
        answer.setAttribute('aria-hidden', 'true');
      } else {
        item.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
        answer.style.maxHeight = answer.scrollHeight + 'px';
        answer.setAttribute('aria-hidden', 'false');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function parseVariants(str) {
      var map = {};
      if (!str) return map;
      str.split(',').forEach(function(entry) {
        var parts = entry.split(':');
        if (parts.length >= 2) {
          map[parts[0]] = { id: parts[1], price: parts[2] || null };
        }
      });
      return map;
    }

    function hasSize(sizesStr, size) {
      var arr = sizesStr.split(',').filter(function(s) { return s !== ''; });
      return arr.indexOf(size) !== -1;
    }

    function formatMoney(cents) {
      return (cents / 100).toFixed(2);
    }

    var pills = document.querySelectorAll('[data-size-filter] [data-size]');
    pills.forEach(function(pill) {
      pill.addEventListener('click', function() {
        pills.forEach(function(p) { p.classList.remove('catalog__size-pill--active'); });
        pill.classList.add('catalog__size-pill--active');
        var size = pill.getAttribute('data-size');
        var cards = pill.closest('.catalog__inner').querySelectorAll('.product-card');
        cards.forEach(function(card) {
          var badge = card.querySelector('.product-card__badge');
          var btn = card.querySelector('.product-card__button');
          var idInput = card.querySelector('input[name="id"]');
          var priceEl = card.querySelector('[data-product-price]');
          var variants = parseVariants(card.getAttribute('data-variants'));
          var isProductAvailable = card.getAttribute('data-available') === 'true';
          card.style.display = '';

          function setAvailable(c, b, bt) {
            c.style.opacity = '';
            if (b) b.style.display = 'none';
            if (bt) {
              bt.disabled = false;
              bt.type = 'submit';
              bt.classList.remove('product-card__button--disabled');
              bt.textContent = bt.getAttribute('data-add-text') || bt.textContent;
            }
          }

          function setSoldOut(c, b, bt) {
            c.style.opacity = '0.5';
            if (b) b.style.display = '';
            if (bt) {
              bt.disabled = true;
              bt.type = 'button';
              bt.classList.add('product-card__button--disabled');
              bt.textContent = bt.getAttribute('data-sold-text') || bt.textContent;
            }
          }

          if (size === 'all') {
            if (isProductAvailable) {
              setAvailable(card, badge, btn);
            } else {
              setSoldOut(card, badge, btn);
            }
          } else {
            var sizes = card.getAttribute('data-sizes') || '';
            if (hasSize(sizes, size)) {
              setAvailable(card, badge, btn);
              if (variants[size]) {
                if (idInput) idInput.value = variants[size].id;
                if (priceEl && variants[size].price) {
                  var cents = parseInt(variants[size].price, 10);
                  priceEl.setAttribute('data-price-cents', cents);
                  priceEl.textContent = window.W4U ? W4U.formatPrice(cents) : '€' + formatMoney(cents);
                }
              }
            } else {
              setSoldOut(card, badge, btn);
            }
          }
        });
      });
    });

    var sgBtn = document.querySelector('[data-catalog-size-guide-toggle]');
    var sgModal = document.querySelector('[data-size-guide-modal]');
    if (sgBtn && sgModal) {
      sgBtn.addEventListener('click', function() {
        sgModal.classList.add('size-guide-modal--open');
        sgModal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
      sgModal.querySelectorAll('[data-size-guide-close]').forEach(function(el) {
        el.addEventListener('click', function() {
          sgModal.classList.remove('size-guide-modal--open');
          sgModal.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        });
      });
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && sgModal.classList.contains('size-guide-modal--open')) {
          sgModal.classList.remove('size-guide-modal--open');
          sgModal.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-modal-target]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var modalId = btn.getAttribute('data-modal-target');
        var modal = document.getElementById(modalId);
        if (modal) {
          modal.classList.add('footer-modal--open');
          modal.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
          document.documentElement.style.overflow = 'hidden';
        }
      });
    });

    document.querySelectorAll('[data-footer-modal-close]').forEach(function(el) {
      el.addEventListener('click', function() {
        var modal = el.closest('.footer-modal');
        if (modal) {
          modal.classList.remove('footer-modal--open');
          modal.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
          document.documentElement.style.overflow = '';
        }
      });
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.footer-modal--open').forEach(function(modal) {
          modal.classList.remove('footer-modal--open');
          modal.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
          document.documentElement.style.overflow = '';
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    var header = document.querySelector('[data-header]');
    var mobileMenu = document.querySelector('[data-mobile-menu]');
    var menuToggle = document.querySelector('[data-mobile-menu-toggle]');
    var menuClose = document.querySelector('[data-mobile-menu-close]');
    var dropdownToggles = document.querySelectorAll('[data-mobile-dropdown-toggle]');

    if (header) {
      window.addEventListener('scroll', function() {
        if (window.scrollY > 10) {
          header.classList.add('header--scrolled');
        } else {
          header.classList.remove('header--scrolled');
        }
      }, { passive: true });
    }

    if (menuToggle && mobileMenu) {
      menuToggle.addEventListener('click', function() {
        mobileMenu.classList.add('header__mobile-nav--open');
        menuToggle.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflow = 'hidden';
      });
    }

    if (menuClose && mobileMenu) {
      menuClose.addEventListener('click', function() {
        mobileMenu.classList.remove('header__mobile-nav--open');
        if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = '';
      });
    }

    if (mobileMenu) {
      mobileMenu.querySelectorAll('.header__mobile-nav-link').forEach(function(link) {
        link.addEventListener('click', function() {
          mobileMenu.classList.remove('header__mobile-nav--open');
          if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
          document.documentElement.style.overflow = '';
        });
      });
    }

    dropdownToggles.forEach(function(toggle) {
      toggle.addEventListener('click', function() {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        var submenu = toggle.nextElementSibling;
        toggle.setAttribute('aria-expanded', String(!expanded));
        if (submenu) submenu.classList.toggle('header__mobile-submenu--open');
      });
    });

    /* Language switcher */
    var langToggle = document.querySelector('[data-lang-toggle]');
    var langDropdown = document.querySelector('[data-lang-dropdown]');
    if (langToggle && langDropdown) {
      langToggle.addEventListener('click', function(e) {
        e.stopPropagation();
        langDropdown.classList.toggle('header__lang-dropdown--open');
      });
      document.addEventListener('click', function() {
        langDropdown.classList.remove('header__lang-dropdown--open');
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function() {
    /* --- Thumbnail gallery --- */
    var thumbs = document.querySelectorAll('.product-gallery__thumb');
    var mainImage = document.getElementById('ProductMainImage');

    if (thumbs.length && mainImage) {
      thumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          thumbs.forEach(function(t) { t.classList.remove('product-gallery__thumb--active'); });
          thumb.classList.add('product-gallery__thumb--active');
          mainImage.src = thumb.getAttribute('data-full-src');
          mainImage.alt = thumb.getAttribute('data-alt') || '';
        });
      });
    }

    /* --- Size pill selector --- */
    var sizePills = document.querySelectorAll('.product-info__size-pill');
    var variantInput = document.getElementById('ProductVariantId');
    var priceEl = document.querySelector('.product-info__price');
    var addBtn = document.getElementById('AddToCartBtn');

    sizePills.forEach(function(pill) {
      var radio = pill.querySelector('input[type="radio"]');
      if (!radio) return;

      radio.addEventListener('change', function() {
        sizePills.forEach(function(p) { p.classList.remove('product-info__size-pill--active'); });
        pill.classList.add('product-info__size-pill--active');

        if (variantInput) {
          variantInput.value = radio.getAttribute('data-variant-id');
        }
        if (priceEl && radio.getAttribute('data-price')) {
          var varCents = parseInt(radio.getAttribute('data-variant-cents'), 10);
          if (window.W4U && !isNaN(varCents)) {
            priceEl.textContent = W4U.formatPrice(varCents);
            priceEl.setAttribute('data-price-cents', varCents);
          } else {
            priceEl.textContent = radio.getAttribute('data-price');
          }
        }
        if (addBtn) {
          var available = radio.getAttribute('data-available') === 'true';
          addBtn.disabled = !available;
          if (available) {
            addBtn.textContent = addBtn.getAttribute('data-add-text') || addBtn.textContent;
          } else {
            addBtn.textContent = addBtn.getAttribute('data-sold-text') || addBtn.textContent;
          }
        }
        var inv = parseInt(radio.getAttribute('data-inventory'), 10);
        var maxQty = (isNaN(inv) || inv <= 0) ? 99 : inv;
        if (qtyInput) {
          qtyInput.max = maxQty;
          if (parseInt(qtyInput.value, 10) > maxQty) qtyInput.value = maxQty;
          if (parseInt(qtyInput.value, 10) < 1) qtyInput.value = 1;
        }
      });
    });

    /* --- Quantity controls --- */
    var qtyInput = document.getElementById('QuantityInput');
    var decreaseBtn = document.getElementById('QuantityDecrease');
    var increaseBtn = document.getElementById('QuantityIncrease');

    if (qtyInput && decreaseBtn && increaseBtn) {
      decreaseBtn.addEventListener('click', function() {
        var val = parseInt(qtyInput.value, 10);
        if (val > 1) qtyInput.value = val - 1;
      });
      increaseBtn.addEventListener('click', function() {
        var val = parseInt(qtyInput.value, 10);
        var max = parseInt(qtyInput.max, 10) || 99;
        if (val < max) qtyInput.value = val + 1;
      });
      qtyInput.addEventListener('change', function() {
        var val = parseInt(qtyInput.value, 10);
        var max = parseInt(qtyInput.max, 10) || 99;
        if (isNaN(val) || val < 1) qtyInput.value = 1;
        if (val > max) qtyInput.value = max;
      });
    }

    /* --- Tabs --- */
    var tabButtons = document.querySelectorAll('.product-tabs__tab');
    var tabPanels = document.querySelectorAll('.product-tabs__panel');

    tabButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var targetId = btn.getAttribute('data-tab');

        tabButtons.forEach(function(b) { b.classList.remove('product-tabs__tab--active'); });
        tabPanels.forEach(function(p) { p.classList.remove('product-tabs__panel--active'); });

        btn.classList.add('product-tabs__tab--active');
        var target = document.getElementById(targetId);
        if (target) target.classList.add('product-tabs__panel--active');
      });
    });

    /* --- Size guide modal --- */
    var modal = document.getElementById('SizeGuideModal');
    var openBtn = document.getElementById('SizeGuideOpen');
    var closeBtn = document.getElementById('SizeGuideClose');
    var backdrop = document.getElementById('SizeGuideBackdrop');

    function openModal() {
      if (modal) {
        modal.classList.add('size-guide-modal--open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
    }
    function closeModal() {
      if (modal) {
        modal.classList.remove('size-guide-modal--open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    }

    if (openBtn) openBtn.addEventListener('click', openModal);
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (backdrop) backdrop.addEventListener('click', closeModal);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeModal();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
